import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Bell({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M9.00023 18V18.25C9.00023 19.9 10.3402 21.25 12.0002 21.25C13.6502 21.25 15.0002 19.9 15.0002 18.25V18M18.0002 13.75L19.7002 15.45C19.8802 15.63 19.9902 15.89 19.9902 16.15V16.98C19.9902 17.53 19.5402 17.98 18.9902 17.98H4.99023C4.43023 17.98 3.99023 17.53 3.99023 16.98V16.14C3.99023 15.87 4.09023 15.62 4.28023 15.43L5.98023 13.72V9.47C5.98023 6.15 8.66023 3.47 11.9802 3.47C15.2902 3.469 17.9802 6.15 17.9802 9.47L18.0002 13.75Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Bell;